import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import Avatar from '@mui/material/Avatar';
import { useAutocomplete } from '@mui/base/useAutocomplete';
import CheckIcon from '@mui/icons-material/Check';
import { useSelector, useDispatch } from 'react-redux';
import CloseIcon from '@mui/icons-material/Close';
import { styled } from '@mui/material/styles';
import { autocompleteClasses } from '@mui/material/Autocomplete';
import { toast } from 'react-toastify';
import { listCoUser } from '../../../../store/features/listCoUser';
import './style.css';
import { useNavigate, useParams } from 'react-router-dom';
import { ListGroupIndiApi } from '../../../../store/features/ListGroupIndividual';

const Root = styled('div')(
  ({ theme }) => `
  color: ${
  theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.65)' : 'rgba(0,0,0,.85)'
};
  font-size: 14px;
`,
);

const Label = styled('label')`
  padding: 0 0 4px;
  line-height: 1.5;
  display: block;
`;

const InputWrapper = styled('div')(
  ({ theme }) => `
  width: 300px;
  border: 1px solid ${theme.palette.mode === 'dark' ? '#434343' : '#d9d9d9'};
  background-color: ${theme.palette.mode === 'dark' ? '#141414' : '#fff'};
  border-radius: 4px;
  padding: 1px;
  display: flex;
  flex-wrap: wrap;

  &:hover {
    border-color: ${theme.palette.mode === 'dark' ? '#177ddc' : '#40a9ff'};
  }

  &.focused {
    border-color: ${theme.palette.mode === 'dark' ? '#177ddc' : '#40a9ff'};
    box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
  }

  & input {
    background-color: ${theme.palette.mode === 'dark' ? '#141414' : '#fff'};
    color: ${
  theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.65)' : 'rgba(0,0,0,.85)'
};
    height: 30px;
    box-sizing: border-box;
    padding: 4px 6px;
    width: 0;
    min-width: 30px;
    flex-grow: 1;
    border: 0;
    margin: 0;
    outline: 0;
          &::placeholder {
      color: #C5CED6;
    font-weight: 400;
      font-size: 14px;
}
  }
`,
);

function Tag(props) {
   const { name, onDelete, bgColor, ...other } = props;


  return (
    <div {...other} style={{ height: '2.5em',margin:'0.25rem' }}>
       <Avatar
        variant="rounded"
        style={{ margin: 'auto 0.5em auto auto' }}
        src="/broken-image.jpg"
        sx={{
fontSize:'12px',
          width: '25px',
          height: '25px',
           bgcolor: bgColor || '#405261',
        }}
           >
        {name?.charAt(0).toUpperCase()}
      </Avatar>

      <span>{name}</span>
      <CloseIcon style={{ width: '20', height: '20' }} onClick={onDelete} />
    </div>
  );
}

Tag.propTypes = {
  name: PropTypes.string.isRequired,
  onDelete: PropTypes.func.isRequired,
};

const StyledTag = styled(Tag)(
  ({ theme }) => `
  display: flex;
  align-items: center;
  height: 24px;
  margin: 2px;
  line-height: 22px;
  background-color: ${
  theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.08)' : '#fafafa'
};
  border: 1px solid ${theme.palette.mode === 'dark' ? '#303030' : '#e8e8e8'};
  border-radius: 2px;
  box-sizing: content-box;
  padding: 0 4px 0 10px;
  outline: 0;
  overflow: hidden;

  &:focus {
    border-color: ${theme.palette.mode === 'dark' ? '#177ddc' : '#40a9ff'};
    background-color: ${theme.palette.mode === 'dark' ? '#003b57' : '#e6f7ff'};
  }

  & span {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  & svg {
    font-size: 12px;
    cursor: pointer;
    padding: 4px;
  }
`,
);

const Listbox = styled('ul')(
  ({ theme }) => `
  width: 300px;
  margin: 2px 0 0;
  padding: 0;
  position: absolute;
  list-style: none;
  background-color: ${theme.palette.mode === 'dark' ? '#141414' : '#fff'};
  overflow: auto;
  max-height: 250px;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  z-index: 1;

  & li {
    padding: 5px 12px;
    display: flex;

    & span {
      flex-grow: 1;
    }

    & svg {
      color: transparent;
    }
  }

  & li[aria-selected='true'] {
    color : #148dfd;
    & svg {
      color: #1890ff;
    }
  }

  & li.${autocompleteClasses.focused} {
    cursor: pointer;

    & svg {
      color: currentColor;
    }
  }
`,
);
const colorCodesForAvatar = [
  '#405261',
  '#FF4D4F',
  '#FA541C',
  '#FA8C16',
  '#FAAD14',
  '#EB2F96',
  '#FADB14',
  '#A0D911',
  '#52C41A',
  '#5CDBD3',
  '#9254DE',
];

export default function AddCoUser(props) {
  const [allUsers, setAllUsers] = useState([]);
  const [currentGroupUsers, setCurrentGroupUsers] = useState([]);
  const [filteredUsers, setFilteredUsers] = useState([]);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { groupId } = useParams();
  const { setListOfUsers,refreshTrigger } = props;

  const {
    getRootProps,
    getInputLabelProps,
    getInputProps,
    getTagProps,
    getListboxProps,
    getOptionProps,
    groupedOptions,
    value,
    focused,
    setAnchorEl,
  } = useAutocomplete({
    disableCloseOnSelect: true,
    filterSelectedOptions: true,
    clearOnEscape: true,
    id: 'customized-hook-demo',
    defaultValue: [],
    multiple: true,
    options: filteredUsers,
    getOptionLabel: (option) => option.email,
    selectOnFocus: true,
    onChange: (event, newValue) => {
      const selectedEmails = newValue.map((option) => option.email);
      setListOfUsers(selectedEmails);
    },
  });

  const getCurrentGroupUsers = async () => {
    try {
      const response = await dispatch(
        ListGroupIndiApi({
          id: groupId,
        })
      );

      if (response?.payload?.status === 200) {
        const groupData = response?.payload?.data;
        const existingUsers = groupData?.users?.map(user => ({
          id: user.id,
          email: user.email
        })) || [];
        
        setCurrentGroupUsers(existingUsers);
      } else {
        console.error('Failed to fetch group data');
      }
    } catch (error) {
      console.error('Error fetching group users:', error);
    }
  };

  const getUserList = async () => {
    try {
      const listCoUserList = await dispatch(listCoUser());
      
      if (listCoUserList?.payload?.status === 200) {
        if (listCoUserList?.payload?.data?.length > 0) {
          const users = listCoUserList?.payload?.data?.map(item => ({
            id: item.user.id,
            name: item.user.name,
            email: item.user.email,
          }));
          
          setAllUsers(users);
        } else {
          setAllUsers([]);
        }
      } else if (listCoUserList?.payload?.status === 401) {
        toast.error('Login Expired. Please login and try again.', {
          position: 'top-right',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: 'light',
        });
        navigate('/login');
      } else {
        toast.error('Some Error Occurred. Please try again later.', {
          position: 'top-right',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: 'light',
        });
      }
    } catch (error) {
      toast.error(error.message || 'An error occurred', {
        position: 'top-right',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: 'light',
      });
    }
  };

  useEffect(() => {
    if (allUsers.length > 0 && currentGroupUsers.length > 0) {
      const currentUserIds = currentGroupUsers.map(user => user.id);
      const filtered = allUsers.filter(user => !currentUserIds.includes(user.id));
      setFilteredUsers(filtered);
    } else {
      setFilteredUsers(allUsers);
    }
  }, [allUsers, currentGroupUsers]);

  useEffect(() => {
    getCurrentGroupUsers();
    getUserList();
  }, [refreshTrigger]);

  return (
    <Root>
      <div {...getRootProps()}>
        <Label {...getInputLabelProps()}>
          Add Members
        </Label>
        <InputWrapper
          style={{ padding: '0px 16px', borderRadius: '8px' }}
          ref={setAnchorEl}
          className={focused ? 'focused' : ''}
        >
          {value.map((option, index) => (
            <StyledTag key={option.id} name={option.name}  bgColor={colorCodesForAvatar[index % 11]}  {...getTagProps({ index })} />
          ))}
          <input
            placeholder={value.length === 0 ? 'Enter a name or email' : ''}
            style={{ height: '2.5rem' }}
            className="addGroupUser_Cl01"
            
            {...getInputProps()}
          />
        </InputWrapper>
      </div>
      {groupedOptions.length > 0 ? (
        <Listbox {...getListboxProps()}>
          {groupedOptions.map((option, index) => (
            <li style={{ alignItems: 'center' }} key={option.id} {...getOptionProps({ option, index })}>
              <Avatar 
                variant="rounded" 
                style={{ margin: 'auto 0.5em auto auto' }} 
                sx={{ 
                  bgcolor: colorCodesForAvatar[index % 11], 
                  width: '32px', 
                  height: '32px' 
                }}
              >
                {option?.name?.substring(0, 1)}
              </Avatar>
              <span>
                {option.name}
                <p style={{ padding: '3px' }} />
                {option.email}
              </span>
              <CheckIcon fontSize="small" />
            </li>
          ))}
        </Listbox>
      ) : null}
    </Root>
  );
}